module.exports = __webpack_public_path__ + "img/1F635.9a831d64.svg";